import { css } from 'linaria';

export const filterServices = css`
  > div {
    width: 100%;

    @media (--only-largeDesktop) {
      padding: 40px 67px 40px 55px;
    }

    @media (--only-desktop) {
      padding: 40px 20px 40px 56px;
    }
  }
`;

export const filterServicesWrapper = css`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const filterServicesContent = css`
  display: flex;
  flex-direction: column;

  @media (--only-largeDesktop) {
    width: 293px;
  }

  @media (--only-desktop) {
    width: 288px;
  }

  @media (--from-desktop) {
    justify-content: space-between;
  }
`;

export const filterServicesImageMobile = css`
  @media (--from-desktop) {
    display: none;
  }

  @media (--to-desktop) {
    margin-top: 4px;
    margin-bottom: 20px;
  }

  @media (--only-tablet) {
    height: 205px;
  }

  @media (--only-mobile) {
    width: 100%;
  }
`;

export const filterServicesImage = css`
  width: 561px;
  height: 234px;

  @media (--only-desktop) {
    width: 519px;
    height: 205px;
  }

  @media (--to-desktop) {
    display: none;
  }
`;